import React from 'react'
import { Ticket } from '../../../../../models/Ticket'
import EAChip from '../../../../shared/Chip/EAChip'
import { isFuture, format } from "date-fns";
import {
  getPassTypeIconType,
  ICON_COMPONENTS,
  getPassTypeLabel,
  isPassType,
  PassType,
  hasEntranceWarning,
} from "../../../../../utils/TicketPassHelper";
import useDesktopSize from "../../../../../../utils/hooks/useDesktopSize";

interface IProps {
  pass: Ticket;
  isInactive: boolean;
  isExpiringsoon: boolean;
  isExpired: boolean;
}

const PassTag: React.FC<IProps> = ({ pass, isInactive, isExpiringsoon, isExpired }) => {
  const isDesktop = useDesktopSize();
  const IconComponent = ICON_COMPONENTS[getPassTypeIconType(pass.passtype)];

  // Sprawdź czy to jest karnet zajęciowy (passtype 2, ticket false)
  const isClassPassCard = isPassType(pass) && pass.passtype === PassType.CLASS_PASS_SINGLE;

  // Sprawdź czy kończą się wejścia
  const hasLowEntrances = !isExpired && hasEntranceWarning(pass);

  // Sprawdź czy ważność od jest w przyszłości
  const isValidFromFuture = pass.validfrom ? isFuture(new Date(pass.validfrom)) : false;

  // Określ wariant i tekst dla nieaktywnego biletu/karnetu
  const getInactiveChipProps = () => {
    if (isClassPassCard) {
      return {
        variant: "warning" as const,
        // Dla karnetu zajęciowego termin wybierany jest z poziomu harmonogramu,
        // więc chip ma charakter informacyjny, nie jako CTA w tym miejscu.
        label: "Termin wybierzesz w harmonogramie",
      };
    }
    return {
      variant: "error" as const,
      label: isDesktop ? "Aby skorzystać z biletu, wybierz termin" : "Wybierz termin",
    };
  };

  const inactiveChipProps = getInactiveChipProps();

  return (
    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
      {/* Chip z typem biletu - zawsze wyświetlany chyba że wygasły */}
      {!isExpired && <EAChip label={getPassTypeLabel(pass)} icon={<IconComponent />} variant="default" />}

      {/* Chip - bilet wygasł */}
      {isExpired && <EAChip label="Wygasł" variant="dark" />}

      {/* Chip informacyjny - ważność od w przyszłości */}
      {isValidFromFuture && (
        <EAChip label={`Ważny od ${format(new Date(pass.validfrom), "dd.MM.yyyy")}`} variant="default" />
      )}

      {/* Chip ostrzeżenia - wkrótce traci ważność */}
      {isExpiringsoon && <EAChip label="Wkrótce traci ważność" variant="warning" />}

      {/* Chip ostrzeżenia - kończą się wejścia */}
      {hasLowEntrances && <EAChip label="Kończą się wejścia" variant="warning" />}

      {/* Chip błędu/ostrzeżenia - bilet/karnet nieaktywny */}
      {isInactive && <EAChip label={inactiveChipProps.label} variant={inactiveChipProps.variant} />}
    </div>
  );
};

export default PassTag